module.exports = __webpack_public_path__ + "static/media/list-active.00b5c4d4.svg";